import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

let signupReturnModalActive = false;

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        const params = typeof window !== 'undefined' && window.location && window.location.search
            ? new URLSearchParams(window.location.search)
            : null;
        const returnUrl = params ? params.get('return_url') : null;
        this.state = {
            show: false,
            returnUrl: returnUrl,
        };
        this.showTimer = null;
        this.autoCloseTimer = null;
    }

    componentDidMount() {
        if (!this.state.returnUrl || signupReturnModalActive) return;
        signupReturnModalActive = true;
        this.showTimer = window.setTimeout(() => {
            this.showTimer = null;
            this.setState({ show: true });
            this.autoCloseTimer = window.setTimeout(() => {
                this.autoCloseTimer = null;
                signupReturnModalActive = false;
                this.setState({ show: false });
            }, 10000);
        }, 1000);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.show && !prevState.show) {
            this.escapeHandler = (e) => {
                if (e.key === 'Escape') this.handleExplore(e);
            };

            document.addEventListener('keydown', this.escapeHandler);
        }
        if (!this.state.show && prevState.show && this.escapeHandler) {
            document.removeEventListener('keydown', this.escapeHandler);
        }
    }

    componentWillUnmount() {
        if (this.showTimer) window.clearTimeout(this.showTimer);
        if (this.autoCloseTimer) window.clearTimeout(this.autoCloseTimer);
        if (this.escapeHandler) {
            document.removeEventListener('keydown', this.escapeHandler);
        }

        signupReturnModalActive = false;
    }

    handleReturn = () => {
        window.location.href = this.state.returnUrl;
    };

    handleExplore = (e) => {
        e.preventDefault();
        if (this.autoCloseTimer) {
            window.clearTimeout(this.autoCloseTimer);
            this.autoCloseTimer = null;
        }

        signupReturnModalActive = false;
        this.setState({ show: false });
    };

    handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            this.handleExplore(e);
        }
    };

    render(props, { show, returnUrl }) {
        const isLoggedIn = props.user && props.user.logged_in;
        const userName = isLoggedIn && props.user.username;
        const title = (show && returnUrl && userName) ? `You're all set, ${userName}` : "You're all set.";

        return (
            <signup-return-modal>
                {show && returnUrl ? (
                    <div
                        className='signup-abandonment-overlay signup-return-overlay'
                        role='dialog'
                        aria-modal='true'
                        aria-labelledby='signup-return-title'
                        onClick={this.handleOverlayClick}
                    >
                        <div className='signup-abandonment-dialog' onClick={(e) => e.stopPropagation()}>
                            <button
                                type='button'
                                className='signup-return-close'
                                aria-label='Close'
                                onClick={this.handleExplore}
                            >
                                ×
                            </button>
                            <div id='signup-return-title' className='signup-abandonment-title'>
                                {title}
                            </div>
                            <div className='signup-abandonment-message'>
                                Your account has been created and your Journal is ready.
                            </div>
                            <div className='signup-abandonment-buttons'>
                                <button
                                    type='button'
                                    className='signup-abandonment-btn primary'
                                    onClick={this.handleReturn}
                                >
                                    Return to What I Was Doing
                                </button>
                                <a href='#' className='signup-abandonment-link' onClick={this.handleExplore}>
                                    Explore my Benefits
                                </a>
                            </div>
                        </div>
                    </div>
                ) : null}
            </signup-return-modal>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(Component);
